import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useAppSelector } from "../../store/appHooks";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useRouter } from "next/router";
import { ROUTES } from "../../constants/routes";
import {
  Container,
  Dialog,
  Grid,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ChatRooms from "components/messages/chat-rooms";
import ChatMessages from "components/messages/chat-rooms/chat-messages";
import DashboardTabs from "components/dashboard/dashboard-tabs";
import Header from "components/Header";
import { useDispatch } from "react-redux";
import { setConversation, setConversations } from "slices/messagesReducer";
import { useEffect, useState } from "react";
import messagesService from "services/messages.service";
import useQuery from "utils/router.util";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "firebase-config/firebase";

const MessagesPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const params = useParams();
  const query = useQuery();
  const { messagesReducer } = useAppSelector((state) => state);
  const { conversations, conversation, messages } = messagesReducer;
  const convId: any = params?.id || null;
  const [conversationsLocal, setConversationsLocal] =
    useState<any>(conversations);
  // call back on conversation change
  const setConvToState = (resp: Array<any>) => {
    const finalResp = [];
    if (convId === "new") {
      finalResp.push(
        {
          id: "new",
          isNew: true,
          user: query.get("user"),
          fbId: query.get("fbId"),
          img: query.get("img") || "",
        },
        ...resp
      );
    } else {
      finalResp.push(...resp);
    }
    setConversationsLocal(finalResp);
    dispatch(setConversations(finalResp));
    setLoading(false);
  };

  useEffect(() => {
    messagesService.loadConversations(
      setConvToState,
      () => setLoading(conversationsLocal.length > 0 ? false : true),
      () => {
        // dispatch(setConversations([]));
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let conSnap = () => {};
    if (convId !== "new") {
      if (convId) {
        const buildQuery = doc(db, "conversations", convId);
        conSnap = onSnapshot(buildQuery, (resp: any) =>
          dispatch(setConversation({ id: resp.id, ...resp.data() }))
        );
      }
      // const conSnap = messagesService.getConversationOnSnap(
      //   convId ?? "",

      // );
    } else {
      setConversationsLocal((prev: any) => prev.filter((r: any) => !r?.isNew));
      dispatch(setConversations(conversations.filter((r: any) => !r?.isNew)));
    }
    return conSnap;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convId]);

  return (
    <Box>
      <DashboardTabs tab="messages" />
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "none",
            xs: "none",
          },
          px: "4%",
          py: "20px",
          borderBottom: "1px solid #F4F4F4",
        }}
        id="header-msg"
      >
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 600,
            fontSize: "24px",
            lineHeight: "35px",
          }}
        >
          Messages
        </Typography>
      </Box>
      {loading && (
        <Box sx={{ display: "flex", mt: "15px" }}>
          <Box
            sx={{
              width: {
                md: "30%",
                lg: "30%",
                xl: "30%",
                sm: "100%",
                xs: "100%",
              },
              height: {
                md: "70vh",
                lg: "70vh",
                xl: "70vh",
                sm: "50vh",
                xs: "50vh",
              },
            }}
            className="small-scroll"
          >
            <Box display="flex" flexDirection="column" gap="15px" px="20px">
              {[1, 2, 3, 4, 5].map(() => (
                <Skeleton variant="rectangular" sx={{ height: "100px" }} />
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              width: "70%",
              display: {
                sm: "none",
                xs: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            <Box sx={{ width: "90%" }}>
              <Skeleton variant="rectangular" sx={{ height: "80px" }} />
              <Box mt={2}>
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <Skeleton
                    variant="rectangular"
                    sx={{ height: "50px", width: "10%", borderRadius: "10px" }}
                  />
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Skeleton
                    variant="rectangular"
                    sx={{ height: "50px", width: "30%", borderRadius: "10px" }}
                  />
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <Skeleton
                    variant="rectangular"
                    sx={{ height: "50px", width: "20%", borderRadius: "10px" }}
                  />
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Skeleton
                    variant="rectangular"
                    sx={{ height: "50px", width: "10%", borderRadius: "10px" }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {!loading && conversationsLocal.length > 0 && (
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              width: {
                md: "30%",
                lg: "30%",
                xl: "30%",
                sm: "100%",
                xs: "100%",
              },
              height: {
                md: "70vh",
                lg: "70vh",
                xl: "70vh",
                sm: "50vh",
                xs: "50vh",
              },
            }}
            overflow="hidden"
            className="small-scroll"
          >
            <ChatRooms convId={convId} list={conversationsLocal} />
          </Box>
          <Box
            sx={{
              width: "70%",
              display: {
                sm: "none",
                xs: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            <ChatMessages
              convId={convId ?? ""}
              msgs={messages}
              conversation={conversation}
              filterOutNewConversation={() => {
                setLoading(true);
                setConversationsLocal([]);
                dispatch(setConversations([]));
              }}
            />
          </Box>
        </Box>
      )}
      {/* {!loading && conversationsLocal.length > 0 && (
        <Grid container id="container-msg">
          <Grid item md={4} lg={4} xl={4} sm={12} xs={12}>
            <ChatRooms convId={convId} list={conversationsLocal} />
          </Grid>
          <Grid
            item
            md={8}
            lg={8}
            xl={8}
            sm={0}
            xs={0}
            sx={{
              display: {
                sm: "none",
                xs: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            <ChatMessages
              convId={convId ?? ""}
              msgs={messages}
              conversation={conversation}
              filterOutNewConversation={() =>
                setConversationsLocal((prev: any) =>
                  prev.filter((r: any) => !r?.isNew)
                )
              }
            />
          </Grid>
        </Grid>
      )} */}

      {!loading && conversationsLocal.length === 0 && (
        <Box
          sx={{
            mx: "4%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "90%",
            my: "8%",
          }}
        >
          <img src="/assets/img/no-messages.png" alt="" width="271px" />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 700,
              fontSize: "26px",
              lineHeight: "31px",
              mt: "20px",
              mb: "10px",
              textAlign: "center",
            }}
          >
            No Messages Available Yet!
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              mb: "15px",
              textAlign: "center",
            }}
          >
            It appears there are no messages in your inbox at the moment. Feel
            free <br />
            to explore other features while you wait for new messages to arrive.
          </Typography>
        </Box>
      )}

      {(matchesSm || matchesXs) && (
        <Dialog
          open={convId}
          sx={
            {
              //   ".MuiPopover-root": {
              //     mt: "65px",
              //   },
              //   ".MuiBackdrop-root": {
              //     opacity: "0 !important",
              //   },
              // ".MuiDialog-container": {
              //   mt: "65px",
              // },
            }
          }
          fullScreen
          PaperProps={{
            elevation: 0,
          }}
        >
          <Header />
          <ChatMessages
            convId={convId ?? ""}
            msgs={messages}
            conversation={conversation}
            filterOutNewConversation={() => {}}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default MessagesPage;
